import { gql } from "@apollo/client";

export const CREATE_TASKASSIGN = gql`
  mutation createtaskAssign($input: createtaskAssignInput) {
    createtaskAssign(input: $input) {
      assignTo
    }
  }
`;

export const GET_TASTASSIGN = gql`
  query taskAssign {
    taskAssign {
      Id
      createdOn
      assignTo
      taskType
      taskDetails {
        taskName
      }
      assignDetails {
        firstName
        lastName
      }
    }
  }
`;
export const GET_TASKASSIGN_BY_ID = gql`
  query taskAssignById($Id: Int) {
    taskAssignById(Id: $Id) {
      Id
      taskType
      assignTo
    }
  }
`;
export const UPDATE_TASKASSIGN = gql`
  mutation updateTaskAssign($input: updatetaskAssignInput) {
    updateTaskAssign(input: $input)
  }
`;

export const DELETE_TASKASSIGN = gql`
  mutation deleteTaskAssign($Id: Int!) {
    deleteTaskAssign(Id: $Id)
  }
`;
